export default {
  'oms_report.generate-report': 'Generate Reports',
  'oms_report.report-type.title': 'Report(Please select report)',
  'oms_report.report-type.label': 'Report',
  'oms_report.report-type.required': 'Please select report',
  'oms_report.fulfillment_order.summary': 'Fulfillment Order Summary',
  'oms_report.platform_inventory.summary': 'Platform Inventory Summary',
  'oms_report.marketplace_store.label': 'Marketplace Store',
  'oms_report.report_date.label': 'Report Date',
  'oms_report.marketplace_store.placeholder': 'Please select stores',
  'oms_report.from-date.label': 'From Date',
  'oms_report.to-date.label': 'To Date',
  'oms_report.date.placeholder': 'Please select a date',
  'oms_report.generating': 'Generating Report',
  'oms_report.skus.label': 'SKU(s)',
  'oms_report.skus.max-warning': 'Max. {max_cnt} SKU(s) only',
  'oms_report.skus.copy-and-paste-textarea-placeholder':
    'Max. {max_cnt} SKU(s) only (When entering multiple SKU codes at one time, use "," or line break to separate them, such as sku001, sku002.) ',
};
